import React, { useEffect, useMemo, useState } from 'react';
import { Radio } from 'tea-component';
import { selectValByCondition } from '@home/utils/common';
import { IFilterOption } from '../useData';
import classNames from 'classnames';
import '@/pages/benchmark/assets/scss/page/genre/components/MetricTable.scss';

export interface IPlatformFilterProps {
  options: IFilterOption[];
  value?: string;
  isEN: boolean;
  onChange: (value: string) => void;
}

const PlatformFilter = (props: IPlatformFilterProps) => {
  const { options, value: propsValue, onChange, isEN } = props;

  const [value, setValue] = useState<string>();

  useEffect(() => {
    if (propsValue) {
      setValue(propsValue);
    }
  }, [propsValue]);

  const handlChange = (val: string) => {
    setValue(val);
    onChange?.(val);
  };

  // 平台
  const newOptons = useMemo(() => {
    const newCountryOpts = options?.map((item: IFilterOption) => {
      const { name_en, name_ch, code } = item;
      return {
        value: code,
        text: selectValByCondition(isEN, name_en, name_ch),
      };
    });
    return newCountryOpts;
  }, [options, isEN]);

  return (
    <div className="dbb-genre-benchmark-filter-col">
      <div className={classNames({ 'is-en': isEN })}>
        {selectValByCondition(isEN, 'Platform', '平台')}
      </div>
      <Radio.Group value={value} onChange={handlChange}>
        {newOptons.map((item) => {
          const { value, text } = item;
          return (
            <Radio key={value} name={value}>
              {text}
            </Radio>
          );
        })}
      </Radio.Group>
    </div>
  );
};
export default PlatformFilter;
